import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=cf8f60aa&scoped=true"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"
import style0 from "./Right.vue?vue&type=style&index=0&id=cf8f60aa&prod&lang=scss&scoped=true"
import style1 from "./Right.vue?vue&type=style&index=1&id=cf8f60aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8f60aa",
  null
  
)

export default component.exports